export default __webpack_public_path__ + "static/media/title_ko_pc.ffeb5bf0.png";